import Button from "../../components/Button";
import Icon from "../../components/icons/Icon";
import Sheet from "../../components/Sheet";
import "./WiederholungDialog.css";

/** Der Song lief in dieser Runde schon — die Playlist ist vermutlich durch. */
export default function WiederholungDialog({ onWeiter, onBeenden }) {
  return (
    // Antippen daneben schliesst bewusst nicht: hier soll entschieden werden
    <Sheet mitte className="wiederholung" onClose={() => {}}>
      <span className="wiederholung-ikon">
        <Icon name="nochmal" size={26} />
      </span>
      <h2>Diesen Song gab's schon</h2>
      <p>
        Die Playlist ist vermutlich einmal durch. Ihr könnt weiterspielen – dann kommen Songs doppelt – oder das Spiel
        beenden.
      </p>
      <Button variant="haupt" onClick={onWeiter}>
        <Icon name="play" />
        Weiterspielen
      </Button>
      <Button variant="neben" onClick={onBeenden}>
        <Icon name="flagge" />
        Spiel beenden
      </Button>
    </Sheet>
  );
}
